import { render } from "./ImportGoalsModal.vue?vue&type=template&id=5a4f2686&scoped=true"
import script from "./ImportGoalsModal.vue?vue&type=script&lang=js"
export * from "./ImportGoalsModal.vue?vue&type=script&lang=js"

import "./ImportGoalsModal.vue?vue&type=style&index=0&id=5a4f2686&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4f2686"]])

export default __exports__